import data from './Accomodation.yaml'
import { nanoid } from 'nanoid'
import { Helmet } from 'react-helmet-async'
import useCurrentLang from '../Components/useCurrentLang';
import PageHeader from '../Components/PageHeader/PageHeader';
import { PageSectionImg, PageSectionContentChild } from '../Components/PageSections/PageSections';
import usePhGallery from '../Components/withPhGallery';

function subcaption(text){
  if(text.toString().includes('http')){
    let words = text.split(' ')
    let newwords = words.map(word => {
      if(word.toString().startsWith('http')){ 
        return <a target='_blank' href={`${word}`} rel="noreferrer" >{word}</a>
      }
      return word
    })
    let newtext = newwords.filter(s=>typeof s !== 'object').join(' ') + ' '
    let result = [newtext, ...newwords.filter(s=>typeof s === 'object')]
    return <>
    {result.map(w => w)}
    </>
  }
  return text
}

function subcaption2(text){
  subcaption3(text.toString())
  if(text.toString().includes('http')){
    let words = text.split(' ')
    let newwords = words.map(word => {
      if(word.toString().startsWith('http')){ 
        return `<a target="_blank" href="${word}">${word}</a>`
      }
      return word
    })
    let newtext = newwords.join(' ')
    return <span dangerouslySetInnerHTML={{__html: newtext}}></span>
  }
  return text
}

function subcaption3(text){
  // if (typeof text === 'string') {
  //   console.log(typeof text)
  // }
  // else{
  //   console.log('not a string', typeof text)
  // }
  // console.log(text)
    // let matches = text.match(/\[(.*)\]\((.*)\)/)
    // console.log('matches',matches)
    // let newstr = text.replaceAll(/\[(.*)\]\((.*)\)/g, '<a target="_blank" href="$2">$1</a>')
    // console.log(newstr)
    //return text.toString().includes('http') ? text.replaceAll(/\[(.*)\]\((.*)\)/g, '<a target="_blank" href="$2">$1</a>') : text
    if(text.indexOf('Airbnb')>0){
      return <>
      <div>
        <span dangerouslySetInnerHTML={{__html: text.replace(/\[(.*)\]\((.*)\)/g, '<a style="color:blue" target="_blank" href="$2" rel="noreferrer" >$1</a>')}}></span>
        <span dangerouslySetInnerHTML={{__html: text.replace(/\[(.*)\]\((.*)\)/g, '&nbsp;<a style="color:blue" target="_blank" href="$2" rel="noreferrer" ><img width="98px" height="auto" style="vertical-align:bottom" src="/img/airbnb.svg"/></a>')}}></span>
        
        {false ?
      <button style={{flex:'1',width:'auto', height:'50px', marginLeft:20, fontSize:24,  color:'white', backgroundColor:'#2ab6cc', border:'1px solid gray', borderRadius:'4px'}} 
popovertarget="my-modal" popovertargetaction="toggle">Book with us</button>
      :
      <div style={{marginTop:20}}>
        <p>
          <span style={{fontWeight:'bold'}} >Book directly with us for the best service and availability. <br/>Please send your request to: <a href="mailto:info@kiteglobing.com">info@kiteglobing.com</a>.</span>
        </p>
        
      </div>

      }

        
        </div>



{false && <dialog popover="auto" id="my-modal" >
  <div style={{width:'100%',height:'auto', margin:0, padding:0, display:'flex', justifyContent:'flex-end'}}>
    <button style={{width:36, height:36,margin:0, padding:0}} popovertarget="my-modal" popovertargetaction="hide" className="popup-body-button" >
      <svg viewBox="0 0 36 36" width="36" height="36" style={{stroke: 'white', strokeWidth: 4, strokeLinecap: 'round', strokeLinejoin: 'round', fill: 'none'}}>
        <line x1="10" y1="10" x2="24" y2="24"></line>
        <line x1="24" y1="10" x2="10" y2="24"></line>
      </svg>
    </button>
  </div>
  <div style={{marginRight:20, marginLeft:20}}>
    <h4>Book directly with us for the best service and availability.</h4>
    <h4>Please send your request to:</h4>
    <h4><a href="mailto:info@kiteglobing.com">info@kiteglobing.com</a>.</h4>
  </div>
</dialog>}

      </>
      
    }
    return <>
    <span dangerouslySetInnerHTML={{__html: text.replace(/\[(.*)\]\((.*)\)/g, '<a style="color:blue" target="_blank" href="$2" rel="noreferrer" >$1</a>')}}></span>
    
    </>
}

function AccGallery({ gallery, imgpath }) {
  return <section key={nanoid(6)} className="section-content" style={{ marginTop: 0 }}>
    <div style={{ margin: 'auto 30px', display: 'flex', flexWrap:'wrap', justifyContent: 'center', alignItems: 'center' }}>
      <p style={{ fontFamily: 'Raleway', fontSize: '1.2rem', fontWeight: 'bold', color: 'var(--black-type)' }}>{gallery.caption}</p>
      {!!gallery.subcaption && <p style={{fontFamily: 'Raleway', fontSize: '1.0rem', fontWeight: 'bold', color: 'var(--black-type)' }}>{subcaption3(gallery.subcaption)}</p>}
    </div>
    {usePhGallery(gallery.items, imgpath)}
  </section>;
}

function AccGalleryMini({ gallery, imgpath, subcaption }) {
  return <section key={nanoid(6)} className="section-content" style={{ marginTop: 0 }}>
    <div style={{ margin: 'auto 30px', display: 'flex', flexWrap:'wrap', justifyContent: 'center', alignItems: 'center' }}>
      {/* {!!subcaption && <p style={{fontFamily: 'Raleway', fontSize: '1.0rem', fontWeight: 'bold', color: 'var(--black-type)' }}>{subcaption3(subcaption)}</p>} */}
    </div>
    {usePhGallery(gallery, imgpath, true)}
  </section>;
}

function AccGalleryAirbnb({ gallery, imgpath }) {
  return <section key={nanoid(6)} className="section-content" style={{ marginTop: 0 }}>
    <div style={{ margin: 'auto 30px', display: 'flex', flexWrap:'wrap', justifyContent: 'center', alignItems: 'center' }}>
      <p style={{ fontFamily: 'Raleway', fontSize: '1.2rem', fontWeight: 'bold', color: 'var(--black-type)' }}>{gallery.caption}</p>
      {!!gallery.subcaption && <p style={{fontFamily: 'Raleway', fontSize: '1.0rem', fontWeight: 'bold', color: 'var(--black-type)' }}>{subcaption3(gallery.subcaption)}</p>}
    </div>
    {usePhGallery(gallery.items, imgpath, true, gallery.airbnburl)}
  </section>;
}



export default function Accomodation() {

  const loc = useCurrentLang()
  const yml = data[loc] || data.en
  const metaDesc = yml.metaDescription || yml.title

  const aStyle = {textDecoration:'none', color:'blue'}
  
  return (
    <div>
        <Helmet>
            <title>{yml.title}</title>
            <meta name="description" content={`${metaDesc}`} />
        </Helmet>
        <PageHeader pageTitle={yml.pageTitle}></PageHeader>
        
        <PageSectionImg image={yml.image} imageAlt={yml.imageAlt} imgStyle={{maxWidth:1200}} />
        {yml.content.headings.map(hItem => 
        <PageSectionContentChild key={nanoid(6)} content={hItem} >
          {
            (item)=><>
            {/* {content.text && content.text.map( item => <p key={nanoid(6)} dangerouslySetInnerHTML={{__html: item}}></p>)} 
            {content.text && <p>&nbsp;QQ</p>} */}
            {/*content.map( item => <div key={nanoid(6)}>*/
            <div key={nanoid(6)}>
              {/* <h3 style={{textAlign:'center', fontSize:'1.7rem'}}>{item.subheading}</h3> */}
              {item.text.map( txt => typeof txt == "string" ? !!txt && <p key={nanoid(6)} dangerouslySetInnerHTML={{__html: txt}}></p> : 
              typeof txt == "object" && Array.isArray(txt) ?
                <p key={nanoid(6)}><a style={aStyle} href={txt[1]} target="_blank" rel="noreferrer">{txt[0]}</a></p>
                : 
                <p key={nanoid(6)}><a style={aStyle} href={txt.url} target="_blank" rel="noreferrer">{txt.caption}</a></p>
              )
              }
              {
                item.subcaption && subcaption3(item.subcaption)
              }
              {
                (item.items) && [
                  {gallery:item.items, imgpath:item.imgpath, subcaption: item.subcaption},
                ].map(AccGalleryMini)
              }
              {
                item.subcaption && subcaption3(item.subcaption)
              }
              <p>&nbsp;</p>

            </div> 
            }
            </>
          }
        </PageSectionContentChild>
        )
        }

    </div>
  );
}


